/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Meeesh API
 * The Meeesh API

Rate limiting:
- default: 60 requests/min (applies to all routes).
- write: 60 requests/min (applies to POST/PUT/PATCH/DELETE).
- public: 120 requests/min (applies only to redirect tracker).

Some endpoints may set stricter write limits (e.g., earn start/claim).
On limit, the API returns 429 with a single Retry-After (seconds).
For redirect, clients can include X-Device-Id to ensure device-keyed limits.
 * OpenAPI spec version: 1.0
 */

/**
 * Event type identifier
 */
export type SseEventDtoEvent = typeof SseEventDtoEvent[keyof typeof SseEventDtoEvent];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SseEventDtoEvent = {
  systemmaintenance: 'system.maintenance',
  systemannouncement: 'system.announcement',
  dreamfrozen: 'dream.frozen',
  dreamunfrozen: 'dream.unfrozen',
  dreamapproved: 'dream.approved',
  dreamrejected: 'dream.rejected',
  dreamclosed: 'dream.closed',
  dreamgoal_reached: 'dream.goal_reached',
  dreamdeleted: 'dream.deleted',
  donationinitiated: 'donation.initiated',
  donationreceived: 'donation.received',
  donationconfirmed: 'donation.confirmed',
  donationlarge_received: 'donation.large_received',
  farmingsession_started: 'farming.session_started',
  farmingsession_completed: 'farming.session_completed',
  farmingpoints_claimed: 'farming.points_claimed',
  farmingboost_activated: 'farming.boost_activated',
  referralbonus_earned: 'referral.bonus_earned',
  referralbonus_claimed: 'referral.bonus_claimed',
  referralnew_user: 'referral.new_user',
  referralbonus_expired: 'referral.bonus_expired',
  referralmilestone: 'referral.milestone',
  transactionconfirmed: 'transaction.confirmed',
  transactionfailed: 'transaction.failed',
  transactionstatus_changed: 'transaction.status_changed',
  walletlinked: 'wallet.linked',
  walletunlinked: 'wallet.unlinked',
  withdrawalrequested: 'withdrawal.requested',
  withdrawalapproved: 'withdrawal.approved',
  withdrawalrejected: 'withdrawal.rejected',
  withdrawalcompleted: 'withdrawal.completed',
  withdrawalfailed: 'withdrawal.failed',
  checkinsucceeded: 'checkin.succeeded',
  checkinstreak_milestone: 'checkin.streak_milestone',
  checkinrestore_available: 'checkin.restore_available',
  roulettebig_win: 'roulette.big_win',
  pointsearned: 'points.earned',
  pointsearned_large: 'points.earned_large',
  pointsspent: 'points.spent',
  chancesearned: 'chances.earned',
  chancesspent: 'chances.spent',
  userinactive_reminder: 'user.inactive_reminder',
  userearly_access_granted: 'user.early_access_granted',
  botstart: 'bot.start',
  broadcastmessage: 'broadcast.message',
} as const;
